// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__ALzDd","logo":"footer_logo__B801D","copy":"footer_copy__FlXOj","maxW":"footer_maxW__Xjj2R","flexDesk":"footer_flexDesk__adxij"};